import Booking, { isGuestUser, getBookingNr, } from "../../../../shared/functions/booking";
import Notifications, { notes } from "@phoenixreisen/mithrils/src/notification";
import OfflineOverlay from "../offline/offline.overlay.m";
import AdminNav from "../bluebox/bluebox.m";
import AgencyNav from "../agentur/nav.m";
import User from "@phoenixreisen/user";
import m from "mithril";
import { isExcludedCard } from "../../../uebersicht/shared/model";
import { canSEPA, hasSPA, hasFlights, hasParkingOption, } from "../../../../shared/components/nav/nav.model";
import { isOrient } from "../../../../shared/functions/booking.cruisecheck";
import { hasHTABooked } from "../../../../react/haustuerabholung/shared/fns.booking";
function getNavItems(booking) {
    const standardNavItems = ["UEBERSICHT", "MEINE_EMAIL", "MEIN_PASSWORT"];
    if (!booking)
        return [...standardNavItems];
    const navItems = [];
    if (!isExcludedCard("sepa", booking) && canSEPA(booking))
        navItems.push("MEINE_BANK");
    if (!isExcludedCard("sepa", booking) && !isOrient(booking))
        navItems.push("AUSFLUEGE");
    if (!isExcludedCard("dokumente", booking))
        navItems.push("MEINE_DOKUMENTE");
    if (!isExcludedCard("manifestdaten", booking))
        navItems.push("MANIFESTDATEN");
    if (!isExcludedCard("kontaktverfolgung", booking))
        navItems.push("KONTAKTVERFOLGUNG");
    if (!isExcludedCard("flug", booking) &&
        !isOrient(booking) &&
        hasFlights(booking))
        navItems.push("FLUGINFORMATION");
    if (!isExcludedCard("spa", booking) && !isOrient(booking) && hasSPA(booking))
        navItems.push("SPA");
    if (!isExcludedCard("notfallkontakte", booking))
        navItems.push("NOTFALLKONTAKTE");
    if (!isExcludedCard("mitreisende", booking) && !isOrient(booking))
        navItems.push("MITREISENDE");
    if (!isExcludedCard("sms_assist", booking))
        navItems.push("SMS_ASSIST");
    if (!isExcludedCard("haustuerabholung", booking) && hasHTABooked(booking))
        navItems.push("HAUSTUERABHOLUNG");
    if (!isExcludedCard("visum", booking))
        navItems.push("VISUM");
    if (!isExcludedCard("visum", booking))
        navItems.push("VISUM");
    if (!isExcludedCard("parken", booking) &&
        !isOrient(booking) &&
        hasParkingOption(booking))
        navItems.push("PARKEN");
    if (!isExcludedCard("tefra", booking) && !isOrient(booking))
        navItems.push("TEFRA");
    return [...standardNavItems, ...navItems];
}
export const Layout = {
    oninit: ({ state }) => {
        const { data: booking } = Booking;
        state.navItems = getNavItems(booking);
    },
    onremove: ({ state }) => {
        if (state.timeoutId)
            clearTimeout(state.timeoutId);
    },
    view: ({ state, attrs, children }) => {
        const { navItems } = state;
        const { breadcrumb, hideBreadcrumb, hideBackButton } = attrs;
        return [
            m("mein-phoenix-header", { "asset-url": process.env.ASSETS, breadcrumb: breadcrumb, "hide-back-button": !!hideBackButton, "hide-breadcrumb": !!hideBreadcrumb, env: process.env.ENV, items: navItems }),
            m("main", { class: isGuestUser(getBookingNr(User)) ? "gettoknow-user" : "normal-user" }, children),
            m("mein-phoenix-footer", { title: "f\u00FCr etwas Vorfreude", "asset-url": process.env.ASSETS }),
            User.isPhx() && m(AdminNav, null),
            User.isAgency() && m(AgencyNav, null),
            !User.online && m(OfflineOverlay, null),
            m(Notifications, { list: notes }),
        ];
    },
};
export default Layout;
